import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError, publishReplay, refCount, switchMap } from 'rxjs/operators';
import { ErrorLevel, ErrorType } from 'src/app/models/enums';
import { ICustomNotification } from 'src/app/models/notification/customNotification.interface';
import { IPlayedTicketTO } from 'src/app/models/ticket/transportObjects/playedTicketTO.interface';
import { LoaderService } from 'src/app/services/loader.service';
import { NotificationService } from 'src/app/services/notification.service';
import { BaseService } from 'src/app/services/providers/base.service';
import { UserActivityService } from 'src/app/services/userActivity.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { IBalance } from '../../models/balance.interface';
import { IBalanceTO } from '../../models/balanceTO.interface';
import { IBaseResponse } from '../../models/baseResponse.interface';
import { IBankDataRequest } from '../../models/requests/bankDataRequest.interface';
import { ILoginRequestTM } from '../../models/requests/loginRequestTM.interface';
import { ITransferBalanceAmountRequest } from '../../models/requests/transferBalanceAmountRequest.interface';
import { IResolveAccountNumberResponseData } from '../../models/response/resolveAccountNumberResponseData.interface';
import { ITransferBalanceAmountResponse } from '../../models/response/transferBalanceAmountResponse.interface';
import { IUnregisteredAffiliateResponse } from '../../models/response/unregisteredAffiliateResponse.interface';
import { IShop } from '../../models/shop.interface';
import { IAffiliate } from '../../models/user/affiliate.interface';
import { ICreateOrUpdateAffiliateTO } from '../../models/user/transportedObjects/createOrUpdateAffiliateTO.interface';
import { IRegistrationConfirm } from '../../models/user/registrartionConfirm';
import { IAffiliateSessionTO } from '../../models/user/transportedObjects/affiliateSessionTO.interface';
import { IAffiliateTO } from '../../models/user/transportedObjects/affiliateTO.interface';
import { IBankTO } from '../../models/user/transportedObjects/bankTO.interface';
import { IPayInResponseDA } from '../../models/user/transportedObjects/payinResponceDA.interface';
import { IPayoutResponseDA } from '../../models/user/transportedObjects/payoutResponseDA.interface';
import { IAffiliateSettingDA } from '../../models/settings/DAObjects/affiliateSettingDA.interface';
import { AffiliateRole } from '../../models/util/tmEnums';
@Injectable({
  providedIn: 'root'
})
// tslint:disable-next-line:align
export class AffiliateProviderService extends BaseService {
  constructor(
    private http: HttpClient,
    protected loaderService: LoaderService,
    protected userActivityService: UserActivityService,
    protected notificationService: NotificationService,
    protected storage: StorageService) {
    super(loaderService, userActivityService, notificationService, storage);
  }

  getAllAffiliatesByShopId(id: number): Observable<IAffiliateTO[]> {
    const url = this.tcketManagerBaseUrl + 'affiliate/getAllAffiliatesByShopId' + '/' + id;
    const params = new HttpParams();

    return this.http.get<IBaseResponse>(url).pipe(
        switchMap((response) => {
          if (response?.isSuccess) {
            return of(response.data as IAffiliateTO[]);
          } else {
            this.openErrorNotification(response.failureReason);
            return of(null);
          }
        }),
        catchError(error => of(null)));
  }

  getAllAffiliatesByParentId(id: number): Observable<IAffiliateTO[]> {
    const url = this.tcketManagerBaseUrl + 'affiliate/getAllAffiliatesByParentId' + '/' + id;
    const params = new HttpParams();

    return this.http.get<IBaseResponse>(url).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of(response.data as IAffiliateTO[]);
        } else {
          this.openErrorNotification(response.failureReason);
          return of(null);
        }
      }),
      catchError(error => of(null)));
  }


  // createLogin(id: number, username: string, password: string): Observable<boolean> {
  //   const url = this.tcketManagerBaseUrl + '/createLogin' + '/' + id + '/' + username + '/' + password;
  //   const params = new HttpParams();

  //   return this.http.get(url).pipe(
  //     map(response => response as boolean),
  //     catchError(err => of(null))
  //   );
  // }

  createAffiliate(affiliateRequest: ICreateOrUpdateAffiliateTO): Observable<boolean> {
    const url = this.tcketManagerBaseUrl + 'account/registerAffiliate';
    const body = JSON.stringify(affiliateRequest);
    const params = new HttpParams();

    return this.http.post<IBaseResponse>(url, body, { headers: this.httpHeaders, params }).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of(true);
        } else {
          this.openErrorNotification(response.failureReason);
          return of(null);
        }
      }),
      catchError(error => of(null)));
  }


  continueRegistration(regConfirm: IRegistrationConfirm): Observable<boolean> {
    const url = this.tcketManagerBaseUrl + 'account/continueRegistration';
    const body = JSON.stringify(regConfirm);
    const params = new HttpParams();

    return this.http.post<IBaseResponse>(url, body, { headers: this.httpHeaders, params }).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of(true);
        } else {
          this.openErrorNotification(response.failureReason);
          return of(null);
        }
      }),
      catchError(error => of(null)));
  }


  updateAffiliate(affiliateRequest: IAffiliateTO): Observable<boolean> {
    const url = this.tcketManagerBaseUrl + 'affiliate/updateAffiliate';
    const body = JSON.stringify(affiliateRequest);
    const params = new HttpParams();

    return this.http.post<IBaseResponse>(url, body, { headers: this.httpHeaders, params }).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of(true);
        } else {
          this.openErrorNotification(response.failureReason);
          return of(false);
        }
      }),
      catchError(error => of(false)));
  }

  getAffiliateBalanceByAffiliateId(id: number): Observable<IBalanceTO> {
    const url = this.tcketManagerBaseUrl + 'affiliate/getAffiliateBalanceByAffiliateId' + '/' + id;
    const params = new HttpParams();

    return this.http.get<IBaseResponse>(url).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of(response.data as IBalanceTO);
        } else {
          this.openErrorNotification(response.failureReason);
          return of(null);
        }
      }),
      catchError(error => {
        console.log('!!!!!!!!!!!!!!!!');
        return of(null);
      }
      ));
  }

 getAllBanks(): Observable<IBankTO[]> {
    const url = this.tcketManagerBaseUrl + 'paystack/banks';
    const params = new HttpParams();

    return this.http.get<any>(url).pipe(
      switchMap((response) => {
        if (response?.status) {
          return of(response.data as IBankTO[]);
        } else {
          this.openErrorNotification(response.message);
          return of(null);
        }
      }),
      catchError(error => of(null)));
  }

  validateAccountNumber(accountNumber: string, bankCode: string): Observable<IResolveAccountNumberResponseData> {
    const url = this.tcketManagerBaseUrl + 'paystack/resolveaccountnumber';
    const params = new HttpParams();
    const accountRequest = {
      accountNumber,
      bankCode
    };
    const body = JSON.stringify(accountRequest);

    return this.http.post<any>(url, body, { headers: this.httpHeaders, params }).pipe(
      switchMap((response) => {
        if (response?.status) {
          return of(response.data as IResolveAccountNumberResponseData);
        } else {
          // this.openErrorNotification(response.failureReason);
          return of(null);
        }
      }),
      catchError(error => of(null)));
  }

  updateBankData(regConfirm: IBankDataRequest): Observable<boolean> {
    const url = this.tcketManagerBaseUrl + 'account/updateBankData';
    const body = JSON.stringify(regConfirm);
    const params = new HttpParams();

    return this.http.post<IBaseResponse>(url, body, { headers: this.httpHeaders, params }).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of(true);
        } else {
          this.openErrorNotification(response.failureReason);
          return of(null);
        }
      }),
      catchError(error => of(null)));
  }

  getBankDataByAffiliateId(id: number): Observable<IBankDataRequest> {
    const url = this.tcketManagerBaseUrl + 'affiliate/getBankDataByAffiliateId' + '/' + id;
    const params = new HttpParams();

    return this.http.get<IBaseResponse>(url).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of(response.data as IBankDataRequest);
        } else {
          this.openErrorNotification(response.failureReason);
          return of(null);
        }
      }),
      catchError(error => of(null)));
  }

  getUnregisteredAffiliatesByParentId(id: number): Observable<IUnregisteredAffiliateResponse[]> {
    const url = this.tcketManagerBaseUrl + 'affiliate/getUnregisteredAffiliatesByParentId' + '/' + id;
    const params = new HttpParams();

    return this.http.get<IBaseResponse>(url).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of(response.data as IUnregisteredAffiliateResponse[]);
        } else {
          this.openErrorNotification(response.failureReason);
          return of(null);
        }
      }),
      catchError(error => of(null)));
  }

  transferBalanceAmount(transferBalanceAmount: ITransferBalanceAmountRequest): Observable<ITransferBalanceAmountResponse> {
    const params = new HttpParams();
    const body = JSON.stringify(transferBalanceAmount);

    return this.http.post<IBaseResponse>(`${this.tcketManagerBaseUrl}affiliate/transferBalanceAmount`, body, { headers: this.httpHeaders, params })
      .pipe(
        switchMap((response) => {
          if (response?.isSuccess) {
            return of(response.data as ITransferBalanceAmountResponse);
          } else {
            this.openErrorNotification(response.failureReason);
            return of(null);
          }
        }),
        catchError(error => {
          this.handleError(error, true, true);
          return of(null);
        }));
  }

  getPaginatedSessions(
    dateFrom: Date,
    dateTo: Date,
    affiliateId: number,
    startFrom: number,
    count: number): Observable<{ totalCount: number; affiliateSessions: IAffiliateSessionTO[] }> {
    const params = new HttpParams();
    return this.http.post<IBaseResponse>(`${this.tcketManagerBaseUrl}account/getFilteredAffiliateSessions`, {
      affiliateId,
      startFrom,
      dateFrom: dateFrom.toISOString().replace('Z', ''),
      dateTo: dateTo.toISOString().replace('Z', ''),
      // eslint-disable-next-line id-blacklist
      number: count,
    }).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of({ totalCount: response.data.totalCount, affiliateSessions: response.data.sessions });
        } else {
          return of(null);
        }
      }),
      catchError(error => of(null)));
  }

  checkResetPasswordToken(token: string): Observable<boolean> {
    const params = new HttpParams();
    const checkResetPasswordToken = {
      token
    };
    const body = JSON.stringify(checkResetPasswordToken);

    return this.http.post<IBaseResponse>(`${this.tcketManagerBaseUrl}account/checkResetPasswordToken`, body, { headers: this.httpHeaders, params })
      .pipe(
        map((response) => response?.isSuccess ? true : null),
        publishReplay(1),
        refCount(),
        catchError((err) => {
          console.log(err);
          return of(false);
        }),
      );
  }

  resetPassword(affiliateId: number): Observable<boolean> {
    const params = new HttpParams();
    const resetAffiliatePasswordRequest = {
      affiliateId
    };
    const body = JSON.stringify(resetAffiliatePasswordRequest);

    return this.http.post<IBaseResponse>(`${this.tcketManagerBaseUrl}account/resetAffiliatePassword`, body, { headers: this.httpHeaders, params })
      .pipe(
        map((response) => {
          if (response?.isSuccess) {
            return true;
          } else {
            this.openErrorNotification(response.failureReason);
            return false;
          }

        }),
        publishReplay(1),
        refCount(),
        catchError((err) => {
          console.log(err);
          return of(false);
        }),
      );
  }

  setNewAffiliatePassword(setNewAffiliatePasswordRequest: any): Observable<boolean> {
    const params = new HttpParams();
    const body = JSON.stringify(setNewAffiliatePasswordRequest);

    return this.http.post<IBaseResponse>(`${this.tcketManagerBaseUrl}account/setNewAffiliatePassword`, body, { headers: this.httpHeaders, params })
      .pipe(
        map((response) => response?.isSuccess ? true : null),
        publishReplay(1),
        refCount(),
        catchError((err) => {
          console.log(err);
          return of(false);
        }),
      );
  }

  changeAffiliatePassword(changeAffiliatePassword: any): Observable<IBaseResponse> {
    const params = new HttpParams();
    const body = JSON.stringify(changeAffiliatePassword);

    return this.http.post<IBaseResponse>(`${this.tcketManagerBaseUrl}account/changeAffiliatePassword`, body, { headers: this.httpHeaders, params })
      .pipe(
        switchMap((response) => {
          if (response) {
            return of(response);
          } else {
            return of(null);
          }
        }),
        publishReplay(1),
        refCount(),
        catchError((err) => {
          console.log(err);
          return of(false);
        }),
      );
  }

  changeAffiliateCashierPassword(changeAffiliatePassword: any): Observable<IBaseResponse> {
    const params = new HttpParams();
    const body = JSON.stringify(changeAffiliatePassword);

    return this.http.post<IBaseResponse>(`${this.tcketManagerBaseUrl}account/setNewAffiliateCashierPassword`, body, { headers: this.httpHeaders, params })
      .pipe(
        switchMap((response) => {
          if (response) {
            return of(response);
          } else {
            return of(null);
          }
        }),
        publishReplay(1),
        refCount(),
        catchError((err) => {
          console.log(err);
          return(err);
        }),
      );
  }

  resendRegistrationEmail(idAffiliate: number): Observable<boolean> {
    const params = new HttpParams();
    return this.http.get<IBaseResponse>(`${this.tcketManagerBaseUrl}account/resendRegistrationEmail/${idAffiliate}`, { headers: this.httpHeaders, params })
      .pipe(
        map((response) => response?.isSuccess ? true : null),
        publishReplay(1),
        refCount(),
        catchError((err) => {
          console.log(err);
          return of(false);
        }),
      );
  }

  deleteAffiliate(affiliateId: number): Observable<void> {
    const params = new HttpParams();
    return this.http.delete<IBaseResponse>(`${this.tcketManagerBaseUrl}account/deleteAffiliate/` + affiliateId, { headers: this.httpHeaders, params })
      .pipe(
        switchMap((response) => {
          if (response?.isSuccess) {
            return of(null);
          } else {
            this.openErrorNotification(response.failureReason);
            throwError(response.failureReason);
          }
        }),
        catchError(error => {
          this.handleError(error, true, true);
          return throwError(error);
        }));
  }

  deleteRegistrationAffiliate(affiliateId: number): Observable<void> {
    const params = new HttpParams();
    return this.http.delete<IBaseResponse>(`${this.tcketManagerBaseUrl}account/deleteRegistrationAffiliate/` + affiliateId, { headers: this.httpHeaders, params })
      .pipe(
        switchMap((response) => {
          if (response?.isSuccess) {
            return of(null);
          } else {
            this.openErrorNotification(response.failureReason);
            throwError(response.failureReason);
          }
        }),
        catchError(error => {
          this.handleError(error, true, true);
          return throwError(error);
        }));
  }

  updateRegistrationRequestEmail(registrationId: number, newEmailAddres: string): Observable<boolean> {
    const url = this.tcketManagerBaseUrl + 'account/updateRegistrationAffiliate';
    const body = JSON.stringify({registrationId, email: newEmailAddres});
    const params = new HttpParams();

    return this.http.post<IBaseResponse>(url, body, { headers: this.httpHeaders, params }).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of(true);
        } else {
          this.openErrorNotification(response.failureReason);
          throwError(response.failureReason);
        }
      }),
      catchError(error => this.handleError(error, true, true)));
  }

  deposit(affiliateId: number, amount: number): Observable<IPayInResponseDA> {
    const params = new HttpParams();
    const requset = {
      affiliateId,
      amount,
    };
    const body = JSON.stringify(requset);
    const url = this.tcketManagerBaseUrl + 'Paystack/payin';


    return this.http.post<any>(url, body, { headers: this.httpHeaders, params })
      .pipe(
        switchMap((response) => {
          if (response?.status) {
            return of(response.data as IPayInResponseDA);
          } else {
            this.openErrorNotification(response.message);
            return of(null);
          }
        }),
        catchError(error => this.handleError(error, true, true)));
  }

  withdraw(affiliateId: number, amount: number): Observable<IPayoutResponseDA> {
    const params = new HttpParams();
    const requset = {
      affiliateId,
      amount,
    };
    const body = JSON.stringify(requset);
    const url = this.tcketManagerBaseUrl +  'Paystack/payout';


    return this.http.post<any>(url, body, { headers: this.httpHeaders, params })
      .pipe(
        switchMap((response) => {
          if (response?.status) {
            return of(response.data as IPayoutResponseDA);
          } else {
            this.openErrorNotification(response.message);
            return of(null);
          }
        }),
        catchError(error => this.handleError(error, true, true)));
  }

  createAffiliateSetting(affiliateSetting: IAffiliateSettingDA): Observable<IAffiliateSettingDA> {
    const params = new HttpParams();
    const body = JSON.stringify(affiliateSetting);
    const url = this.tcketManagerBaseUrl + 'AffiliateSetting/CreateAffiliateSetting';


    return this.http.post<IBaseResponse>(url, body, { headers: this.httpHeaders, params })
      .pipe(
        switchMap((response) => {
          if (response?.isSuccess) {
            return of(response.data as IAffiliateSettingDA);
          } else {
            this.openErrorNotification(response.failureReason);
            return of(null);
          }
        }),
        catchError(error => this.handleError(error, true, true)));
  }

  getAllAffiliateSettings(): Observable<IAffiliateSettingDA[]> {
    const url = this.tcketManagerBaseUrl + 'AffiliateSetting/getAllAffiliateSettings';
    const params = new HttpParams();

    return this.http.get<IBaseResponse>(url).pipe(
        switchMap((response) => {
          if (response?.isSuccess) {
            return of(response.data as IAffiliateSettingDA[]);
          } else {
            this.openErrorNotification(response.failureReason);
            return of(null);
          }
        }),
        catchError(error => of(null)));
  }

  getAffiliateSettingItemsById(id: number): Observable<IAffiliateSettingDA> {
    const url = this.tcketManagerBaseUrl + 'AffiliateSetting/getAffiliateSettingById' + '/' + id;
    const params = new HttpParams();

    return this.http.get<IBaseResponse>(url).pipe(
        switchMap((response) => {
          if (response?.isSuccess) {
            return of(response.data as IAffiliateSettingDA[]);
          } else {
            this.openErrorNotification(response.failureReason);
            return of(null);
          }
        }),
        catchError(error => of(null)));
  }

  updateAffiliateSetting(affiliateSetting: IAffiliateSettingDA): Observable<IAffiliateSettingDA> {
    const params = new HttpParams();
    const body = JSON.stringify(affiliateSetting);
    const url = this.tcketManagerBaseUrl + 'AffiliateSetting/UpdateAffiliateSetting';


    return this.http.post<IBaseResponse>(url, body, { headers: this.httpHeaders, params })
      .pipe(
        switchMap((response) => {
          if (response?.isSuccess) {
            return of(response.data as IAffiliateSettingDA);
          } else {
            this.openErrorNotification(response.failureReason);
            return of(null);
          }
        }),
        catchError(error => this.handleError(error, true, true)));
  }

  deleteAffiliateSetting(affiliateSettingId: number): Observable<boolean> {
    const url = this.tcketManagerBaseUrl + 'AffiliateSetting/DeleteAffiliateSetting/' + affiliateSettingId;
    return this.http.delete<IBaseResponse>(url)
      .pipe(
        switchMap((response) => {
          if (response?.isSuccess) {
            return of(true);
          } else {
            this.openErrorNotification(response.failureReason);
            return of(null);
          }
        }),
        catchError(error => this.handleError(error, true, true)));
  }

  addToInitialBalance(value: number): Observable<number> {
    const url = this.tcketManagerBaseUrl + 'affiliate/addToInitialBalance' + '/' + value;
    const params = new HttpParams();

    return this.http.get<IBaseResponse>(url).pipe(
      switchMap((response) => {
        if (response?.isSuccess) {
          return of(response.data.amount);
        } else {
          this.openErrorNotification(response.failureReason);
          return of(null);
        }
      }),
      catchError(error => of(null)));
  }
}

